import { Address, type TypedDataDomain, type TypedDataParameter } from "viem";

import { ChainId, clearingHouseProxy } from "#/config/web3/contractAddresses";

export const Pair = [
  { name: "base", type: "address" },
  { name: "quote", type: "address" },
];

export const UserLimitOrder: TypedDataParameter[] = [
  { name: "deadline", type: "uint256" },
  { name: "instrumentName", type: "string" },
  { name: "size", type: "uint256" },
  { name: "price", type: "uint256" },
  { name: "taker", type: "address" },
  { name: "maker", type: "address" },
  { name: "direction", type: "uint8" },
  { name: "isLiquidation", type: "bool" },
  { name: "isPostOnly", type: "bool" },
  { name: "mmp", type: "bool" },
];

export const EIP712Domain: Record<ChainId, TypedDataDomain> = {
  [ChainId.ARBITRUM]: {
    chainId: ChainId.ARBITRUM,
    name: "Premia",
    verifyingContract: clearingHouseProxy[ChainId.ARBITRUM] as Address,
    version: "1",
  },
  [ChainId.ARBITRUM_SEPOLIA]: {
    chainId: ChainId.ARBITRUM_SEPOLIA,
    name: "Premia",
    verifyingContract: clearingHouseProxy[ChainId.ARBITRUM_SEPOLIA] as Address,
    version: "1",
  },
};

export const withSignatureErrorHandler = async <T>(fn: () => Promise<T>) => {
  try {
    return await fn();
  } catch (error) {
    console.error("Error with signature:", error);
    const errorInstance = error as Error;
    if (errorInstance.name === "UserRejectedRequestError") {
      throw new Error("User cancelled signature");
    }
    throw error;
  }
};
